<template>
  <div class="favourites-content">
    <h2 class="global-title">{{ $t('mbs-select-favourites') }}</h2>
    <AccountCard v-if="list && list.length > 0" @clickView="clickView" :list="list" />
    <p v-else class="no-data">{{ $t('no-favourite') }}</p>
  </div>
</template>

<script>
  import AccountCard from '@/components/AccountCard/index.vue';
  import { mapState } from 'vuex';

  export default {
    components: {
      AccountCard,
    },
    data() {
      return {
        list: [],
      };
    },
    computed: {
      ...mapState(['userInfo']),
    },
    mounted() {
      this.getFvList();
    },
    methods: {
      clickView(data) {
        console.log('data', data);
        const { item, type } = data;
        if (type && type === 'collect') {
          // 点赞切换
          this.cancelFv(item);
        } else {
          const { id, code, type } = item;
          if (type === '1') {
            this.$router.push({
              path: '/lounge/details',
              query: { loungeId: id, loungeCode: code },
            });
          } else {
            this.$router.push({
              path: '/dining/details',
              query: { diningId: id, diningCode: code },
            });
          }
        }
      },
      // 获取收藏权益列表
      async getFvList() {
        this.$loading.show();
        const { userId, sessionId } = this.userInfo;
        const data = {
          lang: localStorage.getItem('lang') || 'en_US',
          userId,
          sessionId,
        };
        try {
          const res = await this.$http.account.getFvList(data);
          if (res?.state === '11') {
            this.$loading.hide();
            this.list = res.payload && res.payload.length > 0 ? res.payload : [];
          }
        } catch (err) {
          console.error(err);
          this.$loading.hide();
        }
      },
      // 取消收藏权益
      async cancelFv(item) {
        this.$loading.show();
        const { userId, sessionId } = this.userInfo;
        const { type, code } = item;
        const data = {
          userId,
          sessionId,
          code,
          type,
        };
        try {
          const res = await this.$http.account.cancelFv(data);
          if (res?.state === '11') {
            await this.getFvList();
          } else {
            this.$loading.hide();
            if (res.note) {
              this.$messageModal.show({
                image: false,
                i18nNeed: false,
                desc: res.note,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
              });
            }
          }
        } catch (err) {
          console.error(err);
          this.$loading.hide();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
</style>
